(function () {
	const initTabsWithProducts = () => {
		const tabsParent = $(".tabs-with-text");
		const tabs = tabsParent.find(".twt__tabs-item");

		tabs.on("click", function () {
			const tabsContent = $(this)
				.closest(".twt__tabs")
				.next()
				.find(".twt__content-item");

			// console.log(this);
			// console.log(tabsContent);

			if (!$(this).is("[data-active]")) {
				$(this).parent().find("[data-active]").removeAttr("data-active");
				$(this).attr("data-active", "");
				tabsContent
					.hide()
					.eq($(this).index())
					.fadeIn(300)
					.css("display", "flex");
			}
		});

		tabsParent.each(function (index, elem) {
			const tabsSlider = elem.querySelector(".twt__tabs");
			const tabsPrev = elem.querySelector(".twt__prev");
			const tabsNext = elem.querySelector(".twt__next");

			let slider = new Swiper(tabsSlider, {
				slidesPerView: "auto",
				spaceBetween: 32,
				freeMode: {
					enabled: true,
					momentum: true,
				},
				navigation: {
					nextEl: tabsNext,
					prevEl: tabsPrev,
				},
				breakpoints: {
					1600: {
						spaceBetween: 64,
					},
				},
				on: {
					afterInit: function() {
						let slidesWidth = 0;
						const offset = window.matchMedia("(min-width: 990px)").matches ? 64 : 32;

						this.slides.forEach(elem => {
							slidesWidth += elem.offsetWidth + offset;
						});

						slidesWidth -= offset;

						if (slidesWidth < this.el.offsetWidth) {
							this.el.querySelector('.twt__nav').style.display = 'none';
						} else {
							this.el.querySelector('.twt__nav').style.display = 'flex';
						}
					}
				}
			});
		});
	};

	const handleCondolenceRestriction = (target) => {
		let condoTab = target.querySelector('.condolences-tab');
		if (condoTab) {
			
			const day = condoTab.getAttribute('data-expoday');
			const hours = condoTab.getAttribute('data-expohour');
			const isBuyingValid = window.isAvisHasValidDate(day, hours);
			// const isCondolenceValid = window.isWithin24HoursAfterExpo(day, hours);

			if (!isBuyingValid) {
				console.log('Buying is restricted');
				// add restricted class to avis box
				condoTab.classList.add('isRestricted');
			}
			else {
				console.log('Buying is not restricted');
				// remove restricted class from avis box
				condoTab.classList.remove('isRestricted');
			}
			// if (!isCondolenceValid) {
			// 	console.log('Condolence is restricted');
			// 	// add restricted class to avis box
			// 	condoTab.classList.add('isCondolenceRestricted');
			// }
			// else {
			// 	console.log('Condolence is not restricted');
			// 	// remove restricted class from avis box
			// 	condoTab.classList.remove('isCondolenceRestricted');
			// }
		}
	};

	const initSection = () => {
		const sections = document.querySelectorAll('.tabs-with-text');

		const sectionResizeObserver = new ResizeObserver((entries) => {
			initTabsWithProducts();
		});

		initTabsWithProducts();

		sections.forEach(item => {
			sectionResizeObserver.observe(item);

			if( item.hasAttribute('data-avis-tab') ) {
				handleCondolenceRestriction(item);
			}
		});
	};

	initSection();

	document.addEventListener("shopify:section:load", function () {
		initSection();
	});
})();
